<template>
  <component
    :is="layout"
    :channels="$section.products"
    :categories="availableCategories"
    :opts="opts"
    class="epg-grid-view--filter"
  ></component>
</template>
<script>
  import { epgSectionMixin } from '../mixins';

  export default {
    mixins: [
      epgSectionMixin,
    ],
    data() {
      return {
        opts: {
          showScrollableHeader: false,
          showReturnToNow: true,
          showCategoriesFilterList: true,
          showLayoutSwitch: false,
        },
      };
    },
  };
</script>
